import React from "react";

const SpeechList = ({ speeches, speakMessage, currentCategory }) => {
  return (
    <section className="speech-list">
      {speeches
        .filter((text) => text.category === currentCategory)
        .map((text, key) => {
          return (
            <div
              className="text-item"
              key={key}
              onClick={(e) => speakMessage(text.text)}
            >
              <p>{text.text}</p>
            </div>
          );
        })}
    </section>
  );
};

export default SpeechList;
